module.exports = __webpack_public_path__ + "static/media/spotify.96e82b1b.svg";